import { mobile } from "../../../mediaQueries"

const styles = theme => ({
    root: {
        display: 'flex',
        opacity: 0,
        padding: '2rem',
        transition: 'opacity 2s cubic-bezier(.4,.28,0,1.03)',
        overflow: 'hidden',
        justifyContent: 'center',
        position: 'relative',
        alignItems: 'center',
        zIndex: 2,
        marginRight: '130px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
            marginRight: '0'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
            order: 1
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            padding: '2rem 1rem',
            width: '100vw',
            marginLeft: '-1rem'
        }
    },
    zoomImg: {
        position: 'relative',
        boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.2)',
        maxHeight: '600px'
    },
    accesibility: {
        color: 'white',
        transition: 'all 0.3s',
        fontFamily: 'Aktiv Grotesk',
        position: 'absolute',
        bottom: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        margin: 0,
        fontSize: '1rem',
        zIndex: '10',
        whiteSpace: 'pre'
    },
    zoomBtn: {
        position: 'absolute',
        height: '40px',
        width: '40px',
        right: '20px',
        bottom: '20px',
        cursor: 'pointer'
    },
    paper: {
        background: 'rgba(0,0,0,0.8)',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        zIndex: 1000,
        width: '100vw',
        position: 'fixed',
        top: 0,
        [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
            marginLeft: '-1rem'
        }
    },
    wrapper: {
        position: 'relative',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 850)]: {
            maxWidth: 'calc(100% - .5rem)'
        }
    },
    closeBtn: {
        height: '20px',
        width: '20px',
        position: 'absolute',
        top: '1rem',
        right: '1rem',
        cursor: 'pointer',
        zIndex: 10
    },
    image: {
        width: '100%',
        minWidth: '440px',
        marginBottom: '-4px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            minWidth: '100%',
        }
    }
})

export default styles